<h2 class="text--h2 text--bold">{{ 'licenses' | translate }}</h2>

<mat-accordion>
  <mat-expansion-panel *ngFor="let applicationGroup of applicationsPerGroup | keyvalue">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ applicationGroup.key.displayName }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-table [dataSource]="getApplications(applicationGroup.key.id)">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let application" class="flex__child-1">
          <div
            [ngClass]="{
              'text--light': application.disallowedAccess?.profileTypes?.includes(
                profileType$ | async
              ),
            }"
          >
            {{ application.displayName }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="set">
        <mat-cell *matCellDef="let application" class="mat-input-cell flex__child-3">
          <mat-form-field class="full-width-field">
            <mat-select
              placeholder="Rol"
              [ngModel]="getSelectedRole(application.key) | async"
              (ngModelChange)="setUseraccess(application.key, $event)"
              data-test="contactperson-authorizations__select-role"
              [disabled]="
                application.disallowedAccess?.profileTypes?.includes(profileType$ | async)
              "
            >
              <mat-option *ngFor="let role of roles$ | async" [value]="role.key">
                {{ role.displayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: ['name', 'set']"></mat-row>
    </mat-table>
  </mat-expansion-panel>
</mat-accordion>
